//config
export * from './products-config'

export * from './lib/products-detail/products-detail'
